export const props = {
  content: {},
};
